import { Component, EventEmitter, ElementRef } from '@angular/core';
import { SearchItem, Job } from '../services/position-services';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';

@Component({
  selector: 'tu-search',
  templateUrl: './search.component.html'
})

export default class SearchComponent {

  formModel: FormGroup;

  constructor(element: ElementRef) {
    this.formModel = new FormGroup({
      'school': new FormControl('AllSchools'),
      'department': new FormControl('AllDepartments'),
      'keyword': new FormControl()
    });

    this.formModel.valueChanges.subscribe(data => {

      let item = new SearchItem();
      item.schoolName = data.school;
      item.departmentName = data.department;
      item.keyword = data.keyword;

      element.nativeElement
        .dispatchEvent(new CustomEvent('update-search', {
          detail: item,
          bubbles: true
        }));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts